import React from 'react';
import { StyledContainer } from './styles';
import { get } from 'global/lib/lodash';
import { useScreen } from 'global/styles';
import useBodyOverflow from 'global/hooks/useBodyOverflow';
import InDoc from 'global/components/InDoc';

export const InteractiveDocument = (props) => {
  const { doc, document } = props;

  const { isUp } = useScreen();

  useBodyOverflow({ hidden: isUp });

  const isIframe = get(doc, '0.document.assetsDir', document?.document?.assetsDir);

  const getLocalHtmlLink = () => {
    const { dir, html } = isIframe;
    return html;
  };

  return (
    <StyledContainer className={props.className}>
      {isIframe && <InDoc url={getLocalHtmlLink()} />}
    </StyledContainer>
  );
};

export default InteractiveDocument;
